import { QuestionTypes } from "@/constants/questionsIds";
import { Question } from "@/types/question";
import { StrapiQuestionsGroup } from "@/types/strapi";

import { FlowTypes } from "./types";

type FlowTypesToBoolean = Partial<Record<FlowTypes, boolean>>;
export const getFlowTypesToBooleanObj = (flowType: FlowTypes | null): FlowTypesToBoolean =>
    Object.values(FlowTypes).reduce<FlowTypesToBoolean>(
        (acc, type) => ({ ...acc, [type as FlowTypes]: type === flowType }),
        {}
    );

// Strapi Master Questions Utils
export const getExperimentsIdsFromStrapiQuestions = (
    questionsGroups: StrapiQuestionsGroup[]
): string[] => questionsGroups.map(({ eppo_key }) => eppo_key);

export const getFormattedQuestions = (questionsGroup: StrapiQuestionsGroup, prefix: string) =>
    questionsGroup.questions.map((question) => ({
        id: question.question_id,
        event: `${prefix}_${question.question_id}`,
        type: question.type,
        title: question.title,
        subtitle: question.subtitle,
        groupTitle: question.header_group,
        ...(question.type === QuestionTypes.Rate ? { maxRate: 5 } : {}),
        answers:
            question.answers?.map((answer) => ({
                id: answer.answer_id,
                text: answer.text,
                description: answer.description,
            })) ?? [],
    })) as Question<QuestionTypes.Radio | QuestionTypes.Checkbox>[];
